import {Injectable, Type} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {MvsCrudModeEnum} from "../../../../core/shared/service/crud/mvs-crud-mode.enum";

/**
 * CRUD access to {@code cw.CwCaseTypeGeneralAgencyNumber} (/mvsa/cw/caseTypeGeneralAgencyNumbers) —
 * the whitelist of Vermittlernummern a case type may be submitted under.
 *
 * <p>Exists as a dedicated service (rather than a route-only registration) because the entity-provider
 * entry carries the CONFIG-PAGE deep link {@code route: 'cw/config'} instead of the API path, exactly
 * like its sibling {@code CwCaseTypeClosureChannelService}. Without this service the alias would
 * resolve to a null CRUD service and every list/widget over it would return silently empty.
 *
 * <p>{@code getObjectComponent} returns null on purpose: the rows are maintained inside the case-type
 * config surface, they have no standalone object page.
 */
@Injectable({
    providedIn: 'root'
})
export class CwCaseTypeGeneralAgencyNumberService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/cw/caseTypeGeneralAgencyNumbers');
    }

    getObjectComponent(mode?: MvsCrudModeEnum): Type<any> {
        return null;
    }

}
